const dynamicPackage = {
  detailedPlan: "Programma dettagliato", // translated
  minimum: "Minimo", // translated
  maximum: "Massimo", // translated
};

export default dynamicPackage;
